export default "__VITE_ASSET__ThB5Jm9J__"